module.exports = __webpack_public_path__ + "static/media/announcement.f1174ba0.svg";